import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import Reveal from './Reveal';
import { SERVICES } from '../mock';
import PatternBg from './PatternBg';

const EMAILS_ART = `${process.env.PUBLIC_URL}/emails-transparent.png`;

export default function Services() {
  return (
    <section id="services" className="relative overflow-hidden bg-[var(--ob-bg)] py-24 md:py-32">
      <PatternBg
        size={128}
        opacity={0.06}
        mask="radial-gradient(110% 110% at 12% 8%, #000 4%, transparent 62%)"
      />
      <div className="relative mx-auto max-w-[1280px] px-5 md:px-8">
        {/* Heading + copy on top */}
        <Reveal>
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-end">
            <div>
              <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ob-accent-dark)]">
                Your Retention Team
              </p>
              <h2 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[var(--ob-ink)] md:text-5xl">
                We serve as your in-house team for email marketing.
              </h2>
            </div>
            <div className="lg:pb-2">
              <p className="text-lg text-[var(--ob-ink-soft)]">
                From strategy to send, we handle 100% of the workload so you can focus on product.
                We respond within 30 minutes and report consistently, so you always know what’s
                being tested next and the plan for the month ahead.
              </p>
            </div>
          </div>
        </Reveal>

        {/* Capabilities arranged as one cohesive horizontal system */}
        <div className="mt-14 grid grid-cols-1 gap-x-8 border-t border-[var(--ob-line)] sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 70}>
              <div className="group flex h-full gap-4 border-b border-[var(--ob-line)] py-6">
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--ob-accent)]/15 text-[var(--ob-accent-dark)] transition-colors group-hover:bg-[var(--ob-accent)] group-hover:text-[var(--ob-dark)]">
                  <Check size={18} />
                </span>
                <div>
                  <h3 className="font-display text-lg font-bold text-[var(--ob-ink)]">{s.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-[var(--ob-ink-soft)]">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Email-work artwork leading directly into the existing CTA */}
        <Reveal>
          <div className="mt-14 flex flex-col items-center md:mt-16">
            <img
              src={EMAILS_ART}
              alt="A selection of genuine OnBrand client email designs for Huel, At Present, Grenade, Sculpted By Aimee and Heights"
              loading="lazy"
              draggable={false}
              className="mx-auto block h-auto w-full max-w-[620px] object-contain"
            />
            <a
              href="https://calendly.com/hello-onbrandadmin/30min" target="_blank" rel="noopener noreferrer"
              className="ob-btn group -mt-1 inline-flex items-center gap-2 rounded-full bg-[var(--ob-ink)] px-9 py-[1.15rem] text-lg font-semibold text-white hover:bg-[var(--ob-dark)] md:mt-3"
            >
              Book A Free Call
              <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
